// src/components/notifications/NotificationsStats.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Card,
  CardContent,
  Typography,
} from '@mui/material';

export default function NotificationsStats({ stats }) {
  const { t } = useTranslation();

  if (!stats) return null;

  const quickStats = {
    total: stats.total_notifications || 0,
    unread: stats.unread_notifications || 0,
    byType: stats.notifications_by_type || {},
    byPriority: stats.notifications_by_priority || {},
  };

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        gap: 2,
        mb: 3,
        flexWrap: 'wrap'
      }}
    >
      <Box sx={{ flex: 1, minWidth: '220px' }}>
        <Card sx={{ height: '100%' }}>
          <CardContent>
            <Typography
              variant="h4"
              color="primary"
              sx={{
                fontWeight: 600,
                mb: 0.5
              }}
            >
              {quickStats.total}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontWeight: 500 }}
            >
              {t('notifications:stats.total_notifications')}
            </Typography>
          </CardContent>
        </Card>
      </Box>

      <Box sx={{ flex: 1, minWidth: '220px' }}>
        <Card sx={{ height: '100%' }}>
          <CardContent>
            <Typography
              variant="h4"
              color="warning.main"
              sx={{
                fontWeight: 600,
                mb: 0.5
              }}
            >
              {quickStats.unread}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontWeight: 500 }}
            >
              {t('notifications:stats.unread')}
            </Typography>
          </CardContent>
        </Card>
      </Box>

      <Box sx={{ flex: 1, minWidth: '220px' }}>
        <Card sx={{ height: '100%' }}>
          <CardContent>
            <Typography
              variant="h4"
              color="error.main"
              sx={{
                fontWeight: 600,
                mb: 0.5
              }}
            >
              {quickStats.byPriority?.urgent || 0}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontWeight: 500 }}
            >
              {t('notifications:stats.urgent')}
            </Typography>
          </CardContent>
        </Card>
      </Box>

      <Box sx={{ flex: 1, minWidth: '220px' }}>
        <Card sx={{ height: '100%' }}>
          <CardContent>
            <Typography
              variant="h4"
              color="success.main"
              sx={{
                fontWeight: 600,
                mb: 0.5
              }}
            >
              {quickStats.byType?.task_assigned || 0}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontWeight: 500 }}
            >
              {t('notifications:stats.tasks_assigned')}
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}